module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_github_accent.svg?9bdab065591f2c47bc1f097e5ef32587";